<!-- Conteúdo quando há empresas -->
<div *ngIf="dataSource.data.length > 0">
  <div class="filtros">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Buscar por nome ou CNPJ</mat-label>
      <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
      <input matInput [(ngModel)]="filtroNome" placeholder="Buscar por nome ou CNPJ" (keyup)="aplicarFiltro()" />
    </mat-form-field>
  </div>

  <table mat-table [dataSource]="dataSource" class="cis-default-table" matSort>
    <ng-container matColumnDef="nomeFantasia">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
      <td mat-cell *matCellDef="let empresa">
        <div>
          <div style="font-weight: bold;">{{ empresa.nomeFantasia }}</div>
          <div style="font-size: 0.875em; color: rgba(0, 0, 0, 0.6);">{{ empresa.razaoSocial }}</div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CNPJ</th>
      <td mat-cell *matCellDef="let empresa">{{ formatarCnpj(empresa.cnpj) }}</td>
    </ng-container>

    <ng-container matColumnDef="estado">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.estado }}</td>
    </ng-container>

    <ng-container matColumnDef="cidade">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cidade</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.cidade }}</td>
    </ng-container>

    <ng-container matColumnDef="acoes" *ngIf="isMasterUser()">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let empresa">
        <button class="remover" (click)="removerEmpresaDoGrupo(empresa.id, empresa.nomeFantasia)"
          title="Remover empresa do grupo">
          <img src="../../../../../assets/svg/icons/trash.svg" alt="Remover" style="width: 16px; height: 16px;" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div class="paginator-container">
    <p class="contagem-texto">{{ textoContagem }}</p>
    <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)" [showFirstLastButtons]="false"
      [selectConfig]="{ disableOptionCentering: true, panelClass: 'custom-paginator-select' }"
      aria-label="Selecionar página de resultados">
    </mat-paginator>
  </div>
</div>

<!-- Mensagem centralizada quando não há empresas -->
<div class="sem-dados" *ngIf="dataSource.data.length === 0 && idGrupo">
  <p>Nenhuma empresa foi adicionada a esse grupo.</p>
</div>